// General
import React, { Component } from 'react';
// Redux
import { connect } from 'react-redux';
// Redux Form
import { Field, reduxForm } from 'redux-form';
// Style
import {
  Button,
  FormGroup,
  FormControl
} from 'react-bootstrap';
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';
// Translation
import { FormattedMessage, injectIntl } from 'react-intl';
import messages from '../../../../locale/messages';
// Internal Components
import submit from './submit';
import InputFieldComponent from '../../../Common/InputFieldComponent/InputFieldComponent';
import SelectFieldComponent from '../../../Common/SelectFieldComponent/SelectFieldComponent';
import validate from './validate';
import bt from '../../../../components/commonStyle.css';
import s from './CurrencyForm.css';

class CurrencyForm extends Component {
  constructor(props) {
    super(props);
  }

  renderFormControl = ({ input, label, type, meta: { touched, error } }) => {
    const { formatMessage } = this.props.intl;
    return (
      <div>
        <FormControl {...input} placeholder={label} type={type} className={bt.formControlInput} id={input.name} />
        {touched && error && <span className={bt.errorMessage}>{formatMessage(error)}</span>}
      </div>
    );
  }

  render() {
    const { error, handleSubmit, submitting } = this.props;
    const { formatMessage } = this.props.intl;
    const enableDisableOptions = [
      { value: 1, label: formatMessage(messages.Enable) },
      { value: 0, label: formatMessage(messages.Disable) }
    ]
    return (
      <div className={cx('maxwidthcenter', 'empty')}>
        <form onSubmit={handleSubmit(submit)}>
          {error && <strong>{formatMessage(error)}</strong>}
          <div className='oneColumnGrid'>
            <Field
              name="symbol"
              type="text"
              component={InputFieldComponent}
              inputClass={bt.formControlInput}
              label={formatMessage(messages.symbol)}
              placeholder={formatMessage(messages.symbol)}
            />
            <Field
              name="isEnable"
              component={SelectFieldComponent}
              label={formatMessage(messages.status)}
              options={enableDisableOptions}
              inputClass={bt.formControlSelect}
            />
          </div>
          <div className={cx('buttonGroupContainer', 'buttonGroupDivider')}>
            <Button className={bt.btnPrimary} bsSize="large" type="submit" disabled={submitting}>
              {formatMessage(messages.add)}
            </Button>
          </div>
        </form>
      </div>
    )
  }
}
CurrencyForm = reduxForm({
  form: "CurrencyForm", // a unique name for this form
  validate,
})(CurrencyForm);

const mapState = (state) => ({
});
const mapDispatch = {};
export default injectIntl(withStyles(bt, s)(connect(mapState, mapDispatch)(CurrencyForm)));